export const environment = {
  production: false,
  apiUrl: 'https://tax-live.nstechs.net/api',
  projectName: 'Kimo',
  projectFavIcon: '/assets/favicon/kimo.ico',
  projectIcon: '/assets/img/kimo_logo.png',
  projectLoginIcon: '/assets/img/kimo_login.svg',
  projectTheme: '/assets/css/kimo-loading.css',
  primaryColor: '#3FC398',
  primaryColorLight: '#def3ea',
  primaryColorDark: '#35a984',
  backgroundGradient: 'linear-gradient(to right, #fff, #71cfac)'
};
